import { useCallback } from 'react';
import { InputParamFilter } from '../../../shared/ui/param-filters/input-param-filter';
import { CountryParamFilter } from 'entities/geo/countries/country-filter/country-param-filter';
import { RegionParamFilter } from 'entities/geo/regions/region-filter/region-param-filter';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FilterWrapper, ValueFormatterContext } from 'shared/ui/filter/filter-wrapper';
import useCountries from 'entities/geo/countries/countries.hook';

export const GeoListFilter = ({ withRegionSearch = false, withCountrySearch = false }: { withRegionSearch?: boolean, withCountrySearch?: boolean }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { list: countries } = useCountries();

  const countryFormatter = useCallback(
    ({ value }: ValueFormatterContext) => {
      const country = countries.find((item) => String(item.id) === value);
      return country ? country.name : value;
    },
    [countries],
  );

  const handleCountryChange = (countryId: string | null) => {
    const newParams = new URLSearchParams(searchParams);
    
    if (countryId) {
      newParams.set('countryId', countryId);
      newParams.delete('regionId');
    } else {
      newParams.delete('countryId');
    }
    newParams.set('page', '0');
    
    navigate(`?${newParams.toString()}`);
  };

  return (
    <FilterWrapper title="Фильтры географии">
      <FilterWrapper.Item label="Название" queryKeys="name">
        <InputParamFilter queryParamName="name" label="Название" />
      </FilterWrapper.Item>

      {withCountrySearch && (
        <FilterWrapper.Item label="Страна" queryKeys="countryId" valueFormatter={countryFormatter}>
          <CountryParamFilter
            queryParamName="countryId"
            label='Страна'
            onCountryChange={handleCountryChange}
          />
        </FilterWrapper.Item>
      )}

      {withRegionSearch && (
        <FilterWrapper.Item label="Регион" queryKeys="regionId">
          <RegionParamFilter queryParamName="regionId" label='Регион' />
        </FilterWrapper.Item>
      )}
    </FilterWrapper>
  );
};
